import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

/** Koraci čarobnjaka, redom. Redoslijed odgovara `stepNumber` u `WizardStep`. */
export const OVERRIDE_STEP_LABELS: string[] = ["Klijent i ključ", "Promjena", "Rok i razlog"];

/** Klijent i ključ se moraju odabrati prije nego se smije skakati po koracima. */
export const OVERRIDE_MANDATORY_STEP_COUNT = 1;

export const ADJUSTMENT_OPTIONS: DropdownOption[] = [
  { value: "Percent", text: "Postotak — prati cjenik" },
  { value: "Absolute", text: "Fiksno — ne prati cjenik" },
];

/** Zadani rok je 12 mjeseci; poseban uvjet bez roka se ne sprema. */
export const DEFAULT_MONTHS = 12;
